// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export async function externalColombiaOutgoingPaymentMapper(userInputValues: UserInputValues): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'externalpayprovider',
    payment_type_code: userInputValues['selectedExternalPayProvider'] ? userInputValues['selectedExternalPayProvider'] : '',
    bank_details: {
      bank_code: userInputValues['selectedExternalPayProviderBank'] ? userInputValues['selectedExternalPayProviderBank'] : '',
      bank_name: userInputValues['selectedExternalPayProviderBankName'] ? userInputValues['selectedExternalPayProviderBankName'] : '',
      account_number: '',
    },
  };
}
